import { StudyStoreState } from '@/enums/study-store-state';
import { IStudyStoreMutations } from '@/interfaces/store/study-store/study-store.mutations.interface';
import { IStudyStoreState } from '@/interfaces/store/study-store/study-store.state.interface';
import { BestFitResult } from '@studyportals/bestfit-api-fe-client';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { TrackedLink } from '@studyportals/domain-client';

export const studyStoreMutations = (
	state: IStudyStoreState,
): IStudyStoreMutations => {
	return {
		setStoreState(storeState: StudyStoreState): void {
			state.storeState = storeState;
		},
		saveFit(fit: Map<ScoreDeterminantType, BestFitResult>): void {
			state.fit = fit;
		},
		saveStudyInformation(
			studyTitle: string | null,
			universityTitle: string | null,
			studyUrl: TrackedLink | null,
			isPremium: boolean | null,
			organizationId: number | null
		): void {
			state.studyTitle = studyTitle;
			state.universityTitle = universityTitle;
			state.referralLink = studyUrl;
			state.isPremium = isPremium;
			state.organizationId = organizationId;
		},
	};
};
